import { useEffect, useRef, useState } from "react";

export const useMinTime = (ms: number) => {
  const [minTimePassed, setMinTimePassed] = useState(true);

  const timeout = useRef<NodeJS.Timeout | undefined>(undefined);

  const start = () => {
    if (!timeout.current) {
      setMinTimePassed(false);

      timeout.current = setTimeout(() => {
        setMinTimePassed(true);
        timeout.current = undefined;
      }, ms);
    }
  };

  useEffect(() => {
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, []);

  return {
    minTimePassed,
    start,
  };
};
